import React from 'react'
import { useSelector } from 'react-redux'

import { Banner, Dot, Muted } from './styled'

/**
 * Демо-режим: запись запрещена на бэкенде (DemoReadOnlyMiddleware), и без явной
 * плашки человек жмёт "Сохранить" и получает непонятную 403.
 */
const DemoBanner = () => {
  const { currentUser } = useSelector(state => state.users)

  if (!currentUser?.is_demo) return null

  const daysLeft = currentUser.demo_days_left

  return (
    <Banner>
      <Dot />
      Демо-режим — только просмотр, изменения не сохраняются
      {typeof daysLeft === 'number' && (
        <Muted>· доступ ещё {daysLeft} дн.</Muted>
      )}
    </Banner>
  )
}

export default DemoBanner
